export default "__VITE_ASSET__Tb$dAFAV__"